import { useCallback, useState } from 'react'

import { useMounted } from '../../../Hooks/useMounted'
import { useAppDispatch } from '../../../Hooks/useAppDispatch'
import { ChargeCodesActions } from '../StoreAdapter'
import { ChargeCodeSchema } from '../../../Schema/ChargeCodeSchema'
import { ChargeCodesAPI } from '../../../Services/API/ChargeCodesAPI'
import { ServiceLocator } from '../../../Services/ServiceLocator'

export const useAddChargeCode = () => {
  const dispatch = useAppDispatch()
  const mounted = useMounted()

  const [processing, setProcessing] = useState(false)
  const [error, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string>(null)

  const addChargeCode = useCallback(
    async (schema: ChargeCodeSchema): Promise<ChargeCodeSchema> => {
      setProcessing(true)
      return ServiceLocator.resolve(ChargeCodesAPI)
        .createEntity(schema)
        .then((schema) => {
          dispatch(ChargeCodesActions.addOne(schema))
          if (mounted.current) {
            setProcessing(false)
            setError(true)
            setErrorMessage(null)
          }
          return schema
        })
        .catch((err) => {
          if (mounted.current) {
            setProcessing(false)
            setError(true)
            setErrorMessage(err.message)
            throw err
          }
          return null
        })
    },
    [dispatch, mounted],
  )

  return {
    processing,
    error,
    errorMessage,
    addChargeCode,
  }
}
